// 表头更新接口
export type updateOrderTypes = {
  mod_id: string;
  type: number;
  field_list: object[];
};
// 表头字段获取接口
export type getOrderTypes = {
  mod_id: string;
  type: number;
};
// 表头mod
export enum Mod {
  STU_TOUCH = 'touchTask', // 学员触达
  REFUND_REVIEW = 'refundReview', // 退费审核
  CORRECT_OVERVIEW = 'correctOverview', // 批改
  REPLAY_COURSE = 'replayCourse', // 回放跟课
  ORDER_DETAIL = 'orderDetail', // 成单明细
  LEARNING_DATA = 'learningData', // 学情数据
  RED_BOOKLET = 'xiaohongshuOrderDetail', // 学情数据
  PLAY_STATUS = 'playbackStatus' // 回放情况
}
// 品牌
export enum Brand {
  xwx = '100',
  xwxsy = '120'
}
// 存储的品牌name
export const BRAND_NAME = 'Teacher-Desk-X-BRAND';
// 前段配置的表头
export const ModSet = [
  Mod.STU_TOUCH,
  Mod.REFUND_REVIEW,
  Mod.CORRECT_OVERVIEW,
  Mod.REPLAY_COURSE,
  Mod.ORDER_DETAIL,
  Mod.LEARNING_DATA,
  Mod.RED_BOOKLET,
  Mod.PLAY_STATUS
];
